<template>
  <div class="container">
    <div class="content">
      <div style="position: relative">
        <img width="100%" src="@/assets/contact.jpg" alt="banner" style="display: block;"/>
        <div class="banner-text">{{lang.contactUs}}</div>
      </div>
      <div class="tit">{{lang.headquater}}</div>
      <div class="artical">
        <div class="paragraph">
          <img src="@/assets/connect/top.png" width="100%" alt="" style="object-fit: cover;">
          <div style="float: left; width: 50%; padding: 10px 5px 0 0; box-sizing: border-box;">
            <img src="@/assets/connect/left.png" width="100%" alt="">
          </div>
          <div style="float: right; width: 50%; padding: 10px 0 0 5px; box-sizing: border-box;">
            <img src="@/assets/connect/right.png" width="100%" alt="">
          </div>
        </div>
        <div class="paragraph">
          <div class="left">
            <p class="icon">
              <img src="@/assets/icon/phone.png" alt="address" />
            </p>
            <p class="title">{{lang.phone}}</p>
            <p class="context">+86 23 62735888</p>
          </div>
          <div class="right">
            <p class="icon">
              <img src="@/assets/icon/mail.png" alt="address" />
            </p>
            <p class="title">{{lang.email}}</p>
            <p class="context" style="color: #2284f6; font-size: 14px;">
              contact@geelyfintech.com
            </p>
          </div>
        </div>
      </div>
    </div>
    <page-footer></page-footer>
  </div>
</template>
<script>
import mapStore from '@/mixins/mapStore'
export default {
  mixins: [
    mapStore('', {
      getters: ['lang', 'china']
    })
  ] 
};
</script>
<style lang="less" scoped>
.content {
  padding-top: 52px;
  .tit {
    font-weight: 500;
    font-size: 18px;
    color: #242A32;
    padding: 0 15px;
    margin-top: 30px;
    height: 24px;
    overflow: hidden;
    span {
      margin-left: 10px;
      font-size: 18px;
    }
  }
}

.artical {
  background: white;
  padding: 20px 15px 30px;
}
.paragraph {
  &::after {
    content: "";
    display: block;
    visibility: hidden;
    clear: both;
  }
  img {
    display: block;
  }
  .artical-title {
    font-size: 18px;
    font-weight: bold;
  }
  .artical-title::after {
    content: "/";
    display: inline-block;
    font-weight: bold;
    font-size: 18px;
    margin-left: 10px;
  }
  .artical-content {
    p {
      margin-top: 20px;
    }
  }
  .title {
    font-size: 15px;
    color: #3D434D;
    font-weight: 600;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .context {
    margin-top: 5px;
    color: #76808e;
    font-size: 15px;
  }
}

.map {
  height: 301px;
  background: red;
  margin: 0 -15px;
  margin-top: 20px;
}

.left {
  float: left;
  width: 50%;
  // padding-right: 40px;
  box-sizing: border-box;
}
.right {
  float: left;
  box-sizing: border-box;
}
.icon {
  margin-top: 34px;
  margin-bottom: 16px;
  height: 25px;
  overflow: hidden;
  img {
    width: 25px;
    height: 25px;
    float: left;
    display: block;
  }
}
</style>
